module.exports = __webpack_public_path__ + "img/NC.a2e32bbb.png";